<template>
  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" style="min-height:400px; padding-bottom:60px">
  </div>
</template>

<script>
location.href = "/admin/adminLogin.html";
</script>

